var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('input');
import { breakpoints, theme } from '@shapeable/theme';
export var InputDefaultProps = {
  type: "text"
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-sizing: border-box;\n    text-transform: none;\n    padding: ", " ", ";\n    font-family: ", ";\n    font-weight: 400;\n    border-radius: 0;\n    border-width: 1px;\n    border-style: solid;\n    border-color: ", ";\n    background: ", ";\n    font-size: 16px;\n    color: ", ";\n    &::placeholder {\n      color: ", ";\n    }\n\n    &:focus {\n      outline: 2px solid ", ";\n    }\n\n    ", "\n\n  "], ["\n    box-sizing: border-box;\n    text-transform: none;\n    padding: ", " ", ";\n    font-family: ", ";\n    font-weight: 400;\n    border-radius: 0;\n    border-width: 1px;\n    border-style: solid;\n    border-color: ", ";\n    background: ", ";\n    font-size: 16px;\n    color: ", ";\n    &::placeholder {\n      color: ", ";\n    }\n\n    &:focus {\n      outline: 2px solid ", ";\n    }\n\n    ", "\n\n  "])), theme.UNIT(4), theme.UNIT(3), theme.FONT('sans'), theme.COLOR('line-mid'), theme.COLOR('canvas'), theme.COLOR('strong'), theme.COLOR('subtle'), theme.COLOR('primary'), function (_a) {
    var hasError = _a.hasError;
    return hasError && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n      outline: 2px solid ", ";\n      &::placeholder {\n        color: ", ";\n      }\n\n    "], ["\n      color: ", ";\n      outline: 2px solid ", ";\n      &::placeholder {\n        color: ", ";\n      }\n\n    "])), theme.COLOR('red'), theme.COLOR('red'), theme.COLOR('red'));
  }),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var Input = function (props) {
  var className = props.className,
    value = props.value,
    onChange = props.onChange,
    placeholder = props.placeholder,
    type = props.type,
    name = props.name,
    id = props.id,
    hasError = props.hasError;
  var handleChange = onChange && function (event) {
    return onChange(event.target.value);
  };
  return React.createElement(My.Container, {
    hasError: hasError,
    id: id || name,
    name: name || id,
    value: value,
    type: type,
    placeholder: placeholder,
    onChange: handleChange,
    className: cls.name(className)
  });
};
Input.defaultProps = InputDefaultProps;
Input.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;